
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 7.74 8.03"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.18 8V4.43H0l.17-1.19h3V.14l1.36-.17v3.27h3.2l-.17 1.19h-3v3.4z"}})])
          )
        }
      }
    